import api from '.'
import { ClockingRuleSchema } from '../../../backend/src/services/resources/clocking-rules/clocking-rule.model'
import {
  ClockingRulesControllerCreationPayload,
  ClockingRulesControllerUpdatePayload,
} from '../../../backend/src/services/resources/clocking-rules/clocking-rules.controller.service.types'
export interface ClockingRules extends ClockingRuleSchema {
  _id: string
}
export type ClockingRulesCreationPayload = ClockingRulesControllerCreationPayload
export type ClockingRulesUpdatePayload = ClockingRulesControllerUpdatePayload

export const get = async (id: string): Promise<ClockingRules> => {
  return await api({
    endpoint: `/clocking-rules/${id}`,
    method: 'get',
    params: {
      sort: '-createdAt',
    },
  })
}

export const fetch = async (params?: any): Promise<ClockingRules[]> => {
  return await api({
    endpoint: '/clocking-rules',
    method: 'get',
    params: {
      sort: 'name',
      ...(params || {}),
    },
  })
}

export const create = async (params: ClockingRulesCreationPayload): Promise<ClockingRules> => {
  return await api({
    endpoint: '/clocking-rules',
    method: 'post',
    params,
  })
}

export const update = async (params: ClockingRulesUpdatePayload): Promise<ClockingRules> => {
  return await api({
    endpoint: `/clocking-rules/${params._id}`,
    method: 'put',
    params,
  })
}
